import { Dispatch, SetStateAction } from 'react';
import { API } from 'apis';
import { getViaAuth, postViaAuth, responseValidator } from 'apis/api';
import {
    BulkSmsPart,
    BulkSmsPartDetail,
    PaginationList,
    RefreshBulkSmsPartStatusResult,
    RetryBulkSmsItemsResult,
    SendBulkSmsBody,
    SendBulkSmsResult,
    User,
} from 'core/domain';

type SetLoading = Dispatch<SetStateAction<boolean>>;

/** یک پارت را می‌فرستد؛ اگر درخواست شکست بخورد null برمی‌گرداند تا همان پارت دوباره تلاش شود. */
export const sendBulkSmsPart = async (body: SendBulkSmsBody): Promise<SendBulkSmsResult | null> => {
    const response: any = await postViaAuth<SendBulkSmsResult>(API.sender.sendBulkSms, body);
    return responseValidator(response?.status) && response.value ? response.value : null;
};

/** یک صفحه از کاربران با همان فیلترهای صفحه‌ی «مدیریت کاربران». */
export const getUsersPage = async (
    page: number,
    pageSize: number,
    query: string,
): Promise<PaginationList<User> | null> => {
    const response: any = await getViaAuth<PaginationList<User>>(`${API.users.getAll}/${page}/${pageSize}${query}`);
    return responseValidator(response?.status) && response.value ? response.value : null;
};

// امضا مطابق انتظار کامپوننت Table/Pagination است.
export const getBulkSmsParts = async (
    setLoading: SetLoading,
    setData: Dispatch<SetStateAction<PaginationList<BulkSmsPart> | undefined>>,
    page: number,
    pageSize: number,
    query?: string,
) => {
    setLoading(true);
    await getViaAuth<PaginationList<BulkSmsPart>>(`${API.sender.bulkSmsParts}/${page}/${pageSize}${query || ''}`).then(
        (response: any) => {
            setLoading(false);
            if (responseValidator(response.status) && response.value) setData(response.value);
        },
    );
};

export const getBulkSmsPartItems = async (
    setLoading: SetLoading,
    setData: Dispatch<SetStateAction<BulkSmsPartDetail | undefined>>,
    partId: string,
    onlyFailed: boolean,
) => {
    setLoading(true);
    await getViaAuth<BulkSmsPartDetail>(
        `${API.sender.bulkSmsPartItems}/${partId}${onlyFailed ? '?onlyFailed=true' : ''}`,
    ).then((response: any) => {
        setLoading(false);
        if (responseValidator(response.status) && response.value) setData(response.value);
    });
};

/** itemIds خالی یعنی همه‌ی ناموفق‌های پارت. */
export const retryBulkSmsItems = async (
    setLoading: SetLoading,
    partId: string,
    itemIds?: string[],
): Promise<RetryBulkSmsItemsResult | null> => {
    setLoading(true);
    const response: any = await postViaAuth<RetryBulkSmsItemsResult>(API.sender.retryBulkSmsItems, {
        partId,
        itemIds,
    });
    setLoading(false);
    return responseValidator(response?.status) && response.value ? response.value : null;
};

export const refreshBulkSmsPartStatus = async (
    setLoading: SetLoading,
    partId: string,
): Promise<RefreshBulkSmsPartStatusResult | null> => {
    setLoading(true);
    const response: any = await postViaAuth<RefreshBulkSmsPartStatusResult>(API.sender.refreshBulkSmsPartStatus, {
        partId,
    });
    setLoading(false);
    return responseValidator(response?.status) && response.value ? response.value : null;
};
